export default "__VITE_ASSET__6ef0214c__"